export default {
  maxFetchSize: 10000,
  normalFetchSize: 10,
  processedQueueName: 'finishing_task',
};
